export enum PeriodicityType {
  'Last Month' = 1,
  'Last Year' = 2,
  'Current Year' = 3,
  'Last 12 Months' = 4
}
